/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import Constants from '../../Config/Config';
import $ from 'jquery';
import ReactPixel from 'react-facebook-pixel';

export default class CartForm extends Component {

	constructor(props) {
	    super(props);
		this.state = {
			buttonLoading: false,
        }
	    this.submitForm = this.submitForm.bind(this);
  	}

  	submitForm = () => {
		const {customizeQTY, cart1ItemTotal} = this.props;

		if (parseFloat(customizeQTY) > 0) {
			window.location.href = Constants.URL.root+"/cart/";
		} else {
			this.setState({buttonLoading: true});
			const ajaxurl = Constants.URL.root+'/wp-admin/admin-ajax.php';
			setTimeout(() => {
				$.ajax(ajaxurl, {
					method: "POST",
					dataType: 'json',
					data: $('.cartForm').serialize()+'&action=add_item_to_cart&cartTotal='+cart1ItemTotal,
					success: function (res) {
						window.location.href = Constants.URL.root+"/cart/";
						ReactPixel.track( 'AddToCart' );
					}
				});
			}, 1000);
		}
  	}

	render() {
		const {selectedFrame, actualFrameSizeH, actualFrameSizeW, canvasThumbImage, frameImageHeight, frameImageWidth, frameImage, qty, selectedLayout, selectedHanging, canvasFrameTotal, selectedWrapping, selectedStretching, stretchingTotal} = this.props;

		return (
			<form action={Constants.URL.root+"/cart/"} method="post" className="cartForm">
				<input type="hidden" name="quantity" value={qty} />
				{/* <input type="hidden" name="frameTotal" value={stretchingTotal} /> */}
				{selectedLayout.size > 0 &&
					<>
						<input type="hidden" name="item_id" value={selectedLayout.get('id')} />
						<input type="hidden" name="product_name" value={selectedLayout.get('name')} />
					</>
				}
				{selectedWrapping.size > 0 &&
					<input type="hidden" name="wrappingName" value={selectedWrapping.getIn(['title', 'rendered'])} />
				}
				{selectedStretching.size > 0 &&
					<>
						<input type="hidden" name="stretchingName" value={selectedStretching.getIn(['title', 'rendered'])} />
						<input type="hidden" name="stretchingTotal" value={stretchingTotal} />
					</>
				}
				{selectedHanging.size > 0 &&
					<input type="hidden" name="hangingName" value={selectedHanging.getIn(['title', 'rendered'])} />
				}
				{selectedFrame.size > 0 &&
					<>
						<input type="hidden" name="frameName" value={selectedFrame.get('name')} />
						<input type="hidden" name="frameTotal" value={canvasFrameTotal} />
						<input type="hidden" name="frameWidth" value={actualFrameSizeW} />
						<input type="hidden" name="frameHeight" value={actualFrameSizeH} />
					</>
				}
				{frameImage !== null &&
					<input type="hidden" name="frameImageOriginal" value={frameImage} />
				}
				{canvasThumbImage !== null &&
					<input type="hidden" name="canvasImage" value={canvasThumbImage} />
				}
				{frameImageHeight !== 0 &&
					<input type="hidden" name="pictureHeight" value={frameImageHeight} />
				}
				{frameImageWidth !== 0 &&
					<input type="hidden" name="pictureWidth" value={frameImageWidth} />
				}
				<button type="button" className="btn btn-danger" onClick={this.submitForm}>
					{this.state.buttonLoading ?
						<div className="loading"></div> :
						<span>{this.props.btnText}</span>
					}
				</button>
			</form>
	    );
	}
}